<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="文件层级">
        <el-input v-model="groupName" disabled></el-input>
      </el-form-item>
      <el-form-item label="目录名称">
        <el-input v-model="form.menuName" disabled></el-input>
      </el-form-item>
      <el-form-item label="文件标题" prop="title">
        <el-input v-model="form.title" maxlength="200" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="文件说明" prop="content">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          v-model="form.content"
          maxlength="400"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="文件上传">
        <VUpload
          :fileList.sync="attachList"
          :limit="1"
          :max="256 * 1024 * 1024"
          :disabled="mode == 'edit'"
        />
      </el-form-item>
      <el-form-item label="浏览权限">
        <el-radio v-model="radio" :label="1" size="small">全部医院</el-radio>
        <el-radio v-model="radio" :label="2" size="small">指定医院</el-radio>
        <el-button
          v-if="radio === 2"
          icon="el-icon-plus"
          size="small"
          type="danger"
          plain
          @click="handleChooseProject"
        ></el-button>
      </el-form-item>
      <el-form-item label="" v-if="radio === 2">
        <el-tag style="margin-right: 10px" v-for="(item, index) in choosenProjects" :key="index">{{
          item.deptName
        }}</el-tag>
      </el-form-item>
      <el-form-item label="下载权限">
        <el-radio v-model="form.downloadFlag" :label="1" size="small">允许下载</el-radio>
        <el-radio v-model="form.downloadFlag" :label="0" size="small">不允许下载</el-radio>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ submitTitle }}</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="请选择"
      :visible.sync="dialogShow"
      width="60%"
      :before-close="handleClose"
      append-to-body
    >
      <el-row gutter="20">
        <el-col span="6"  v-for="(item, index) in projectList" :key="index" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
          <el-checkbox v-model="checkList" :label="item.id" style="" size="small">
            <el-tooltip class="item" effect="dark" :content="item.deptName" placement="top">
            <div >
              {{
                item.deptName
              }}
            </div>
            </el-tooltip>
          </el-checkbox>
        </el-col>
        
      </el-row>
      <template slot="footer">
        <div style="margin: 20px; text-align: center">
          <el-button size="small" type="primary" @click="confirmProject">确定</el-button>
        </div>
      </template>
      
    </el-dialog>
  </div>
</template>

<script>
import VUpload from '@/views/components/v-upload-knowledge';

import {
  saveKnowledgeGroup,
  getKnowledgeGroupSelectById,
  updateKnowledgeGroup,
} from '@/api/crmedical/knowledge/group';

export default {
  components: { VUpload },
  props: ['form', 'projectList', 'mode'],
  data() {
    return {
      groupName: '华润医疗集团文件',
      attachList: [],
      checkList: [],
      dialogShow: false,
      choosenProjects: [],
      radio: 1,
      throttle: false,
      submitTitle: '确定',
      rules: {
        title: [
          { required: true, message: '请输入标题' },
          { min: 1, max: 100, message: '长度在 1 到 50 个字符' },
        ],
        content: [
          { required: true, message: '请输入说明' },
          { min: 1, max: 500, message: '长度在 1 到 500 个字符' },
        ],
      },
    };
  },
  mounted() {
    console.log('this.mode==>', this.mode);
    if (this.mode == 'edit') {
      this.radio = this.form.accessPermission;
      getKnowledgeGroupSelectById({ id: this.form.id }).then((res) => {
        if (res.data.link) {
          this.attachList = [{ link: res.data.link, originalName: res.data.link }];
          this.form.attachIds = res.data.attachIds;
        }
      });
    }
  },
  methods: {
    handleChooseProject() {
      this.dialogShow = true;
    },
    onSubmit() {
      this.$refs.form.validate((v) => {
        console.log('==>', e);
        if (!v) return;

        if (this.attachList.length == 0) {
          this.$message.warning('请上传一个文件');
          return;
        }
        if (this.radio == 2 && this.choosenProjects.length == 0) {
          this.$message.warning('请选择一个医院或者选择全部医院');
          return;
        }

        console.log('this.form==>', this.form);
        if (this.throttle) return;
        this.throttle = true;
        if (this.radio === 1) {
          this.form.projectIds = this.projectList.map((ele) => ele.id).toString();
        } else {
          this.form.projectIds = this.checkList.toString();
        }
        this.form.accessPermission = this.radio;
        if (this.mode == 'edit') {
          const postData = {
            id: this.form.id,
            content: this.form.content,
            title: this.form.title,
            accessPermission: this.form.accessPermission,
            projectIds: this.form.projectIds,
            downloadFlag: this.form.downloadFlag,
            menuId: this.form.menuId,
            attachIds: this.form.attachIds,
          };
          console.log('postData==>', postData);
          updateKnowledgeGroup(postData)
            .then((res) => {
              this.throttle = false;
              this.$message.success(res.msg);
              console.log('res updateKnowledgeGroup==>', res);
              this.$emit('close');
            })
            .catch(() => {
              this.throttle = false;
              this.$emit('close');
            });
        } else {
          this.form.attachIds = this.attachList.map((ele) => ele.id).toString();
          saveKnowledgeGroup(this.form)
            .then((res) => {
              this.throttle = false;
              this.$message.success(res.msg);
              this.$emit('close');
            })
            .catch(() => {
              this.throttle = false;
              this.$emit('close');
            });
        }
      });

      console.log('this.att==>', this.attachList);
    },
    cancel() {
      this.$emit('close');
    },
    confirmProject() {
      this.choosenProjects = this.projectList.filter((item) => {
        return this.checkList.includes(item.id);
      });
      this.dialogShow = false;
    },
  },
};
</script>

<style>
</style>